import { BotConstants, SessionMode } from "../libs/constants/index";

export const authStore = (set) => {
  return {
    //   isLoggedIn: sessionStorage.getItem("isLoggedIn") === "true",
    isLoggedIn: sessionStorage.getItem("isLoggedIn") === "true",
    // TODO : Remove Dependency on username
    username: sessionStorage.getItem("username"),
    firstName: sessionStorage.getItem("firstName"),
    jobTitle: sessionStorage.getItem("jobTitle"),
    organizationName: sessionStorage.getItem("organizationName"),
    organizationContactEmail: sessionStorage.getItem(
      "organizationContactEmail"
    ),
    organizationContactNumber: sessionStorage.getItem(
      "organizationContactNumber"
    ),
    organizationContactCountryCode: sessionStorage.getItem(
      "organizationContactCountryCode"
    ),
    mId: sessionStorage.getItem("mId"),
    meetingId: sessionStorage.getItem("meetingId") ?? null,
    meetingStatus: sessionStorage.getItem("meetingStatus"),
    isOldUI: sessionStorage.getItem("isOldUI") ?? false,
    is2D: sessionStorage.getItem("is2D") ?? false,
    version: sessionStorage.getItem("version") ?? null,
    mode: sessionStorage.getItem("mode") ?? SessionMode.WEB_VIDEO,
    videoAvatarId:
      sessionStorage.getItem("videoAvatarId") ?? BotConstants.VIDEO_AVATAR_ID,
    videoVoiceId:
      sessionStorage.getItem("videoVoiceId") ?? BotConstants.VIDEO_VOICE_ID,
    audioVoiceId:
      sessionStorage.getItem("audioVoiceId") ?? BotConstants.AUDIO_VOICE_ID,
    ultravoxJoinUrl: sessionStorage.getItem("ultravoxJoinUrl"),
    sasUrl: "",
    isDesktop:
      typeof window !== "undefined" &&
      window.matchMedia("(min-width: 1024px)").matches,
    setLogin: (value) => {
      console.log(`[AuthStore] Setting login status:`, { isLoggedIn: value });
      return set((state) => ({ isLoggedIn: value }));
    },
    setMeetingId: (value) => {
      console.log(`[AuthStore] Setting meeting ID:`, { meetingId: value });
      return set((state) => {
        sessionStorage.setItem("meetingId", value);
        return { meetingId: value };
      });
    },
    setUsername: (value) => set((state) => ({ username: value })),
    setFirstName: (value) => set((state) => ({ firstName: value })),
    setJobTitle: (value) => set((state) => ({ jobTitle: value })),
    setOrganizationName: (value) =>
      set((state) => ({ organizationName: value })),
    setOrganizationContactEmail: (value) =>
      set((state) => ({ organizationContactEmail: value })),
    setOrganizationContactNumber: (value) =>
      set((state) => ({ organizationContactNumber: value })),
    setOrganizationContactCountryCode: (value) =>
      set((state) => ({ organizationContactCountryCode: value })),
    setMid: (value) => set((state) => ({ mId: value })),
    setMeetingStatus: (value) => set((state) => ({ meetingStatus: value })),
    setIsOldUI: (value) => set((state) => ({ isOldUI: value })),
    setIs2D: (value) => set((state) => ({ is2D: value })),
    setVersion: (value) => set((state) => ({ version: value })),
    setMode: (value) => set((state) => ({ mode: value })),
    setVideoAvatarId: (value) =>
      set((state) => {
        sessionStorage.setItem("videoAvatarId", value);
        return { videoAvatarId: value };
      }),
    setVideoVoiceId: (value) =>
      set((state) => {
        sessionStorage.setItem("videoVoiceId", value);
        return { videoVoiceId: value };
      }),
    setAudioVoiceId: (value) =>
      set((state) => {
        sessionStorage.setItem("audioVoiceId", value);
        return { audioVoiceId: value };
      }),
    setUltravoxJoinUrl: (value) =>
      set((state) => {
        sessionStorage.setItem("ultravoxJoinUrl", value);
        return { ultravoxJoinUrl: value };
      }),
    setIsDesktop: (value) =>
      set(() => ({
        isDesktop: value,
      })),
    handleLogin: (
      isLogin,
      username,
      mId,
      meetingStatus,
      isOldUI,
      is2D,
      version,
      mode,
      firstName,
      jobTitle,
      organizationName,
      organizationContactEmail,
      organizationContactNumber,
      organizationContactCountryCode
    ) => {
      set((state) => {
        console.log(`[AuthStore] handleLogin - Starting login process:`, {
          isLogin,
          username,
          mId,
          meetingStatus,
          isOldUI,
          is2D,
          version,
          mode,
          firstName,
          jobTitle,
          organizationName
        });
        sessionStorage.setItem("isLoggedIn", "true");
        if (isOldUI) sessionStorage.setItem("isOldUI", "true");
        if (is2D) sessionStorage.setItem("is2D", "true");
        if (["v1", "v2"].includes(version))
          sessionStorage.setItem("version", version);
        else sessionStorage.setItem("version", "v3");
        sessionStorage.setItem("mode", mode);
        sessionStorage.setItem("username", username);
        sessionStorage.setItem("mId", mId);
        sessionStorage.setItem("meetingStatus", meetingStatus);
        sessionStorage.setItem("firstName", firstName);
        sessionStorage.setItem("jobTitle", jobTitle);
        sessionStorage.setItem("organizationName", organizationName);
        sessionStorage.setItem(
          "organizationContactEmail",
          organizationContactEmail
        );
        sessionStorage.setItem(
          "organizationContactNumber",
          organizationContactNumber
        );
        sessionStorage.setItem(
          "organizationContactCountryCode",
          organizationContactCountryCode
        );
        const newState = {
          isLoggedIn: isLogin,
          username: username,
          mId: mId,
          meetingStatus: meetingStatus,
          isOldUI: isOldUI,
        };
        console.log(`[AuthStore] handleLogin - Login completed successfully:`, newState);
        return newState;
      });
    },
    setSasUrl: (value) => {
      console.log(`[AuthStore] Setting SAS URL:`, { hasUrl: !!value, urlLength: value?.length || 0 });
      return set(() => ({ sasUrl: value }));
    },
  };
};
